// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsSummaryStyles {
    productSummary?: TypographyProps;
}

export const productSummaryStyles: ProductDetailsSummaryStyles = {};

const styles = productSummaryStyles;

const ProductDetailsSummary: React.FC<Props> = ({ product }) => {
    return <Typography {...styles.productSummary}>{product?.properties?.productSummary}</Typography>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsSummary),
    definition: {
        displayName: "Product Summary",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
